import { GridCellParams } from '@mui/x-data-grid-pro';
import {
  TEDEKBokforderSTATUSEnum,
  TEDEKBokforderVariantEnum,
  TEDEKBokforingsmallRadDEB_KREDEnum,
} from '../../../../../../globalQueryTypes';
import {
  inDateInterval,
  notNullOrUndefined,
} from '../../../../../../Utils/utils';
import {
  UserBokforderKodbehorigheterQuery_userBokforderKodbehorigheter,
  UserBokforderKodbehorigheterQuery_userBokforderKodbehorigheter_bokforderkodbehorigheter,
} from '../Queries/BokforderKodbehorigheter/_QueryTypes/UserBokforderKodbehorigheterQuery';
import { SUMROWID } from '../../../../_Common/Components/BusinessCollectionComponents/BusinessDataTable/Consts/BusinessDataTableConsts';
import {
  DefaultBfoVariantEnum,
  ITemplateRow,
} from '../Components/BokforderContext/BokforderContextManager';
import { AvenyCollectionMap } from '../../../../../../Model/ModelContext/ModelContext';
import { createUsersWithKodbehorigheter } from './BokforderUtils';

export const getVariantDisplayText = (
  variant: TEDEKBokforderVariantEnum | DefaultBfoVariantEnum
): string => {
  switch (variant) {
    case TEDEKBokforderVariantEnum.KOPIERA:
      return 'Kopiera';
    case TEDEKBokforderVariantEnum.MALL:
      return 'Mall';
    case TEDEKBokforderVariantEnum.OMBOKFOR:
      return 'Ombokför';
    case TEDEKBokforderVariantEnum.PERIODISERA:
      return 'Periodisera';
    case TEDEKBokforderVariantEnum.TOM:
      return 'Tom';
    case TEDEKBokforderVariantEnum.UTANORDINGBANKONTO:
      return 'Bankkonto';
    case TEDEKBokforderVariantEnum.UTANORDINGKONTANT:
      return 'Kontant';

    case TEDEKBokforderVariantEnum.UTANORDINGPGBG:
      return 'PG/BG';
    case TEDEKBokforderVariantEnum.VAND:
      return 'Vand';
    case TEDEKBokforderVariantEnum.UTANORDNINGTILLGODO:
      return 'Tillgodo';
    case DefaultBfoVariantEnum.VERIFIKATION:
      return 'Verifikation';

    default:
      return 'invalid variant';
  }
};

export const createUsersWithKodbehBasedOnType = (
  allUserData: UserBokforderKodbehorigheterQuery_userBokforderKodbehorigheter[],
  avenyCollectionMap: AvenyCollectionMap,
  bokforderDate: Date,
  kodbehType: 'FOR_BOKFORDER' | 'FOR_UTANORDNING' | 'UTANORDNING_KONTROLL',
  userID: string,
  isEconomyPersonnel: boolean
) => {
  const allUsersBasedOnType = allUserData.reduce((validUsers, currentUser) => {
    if (currentUser.bokforderkodbehorigheter && !currentUser.borttagen) {
      const newKodbehorigheter = currentUser?.bokforderkodbehorigheter?.reduce(
        (kodbehArray, currentKodbeh) => {
          if (!notNullOrUndefined(currentKodbeh)) {
            return kodbehArray;
          }
          const isValidByBokforderDate = inDateInterval(
            new Date(currentKodbeh?.giltigFromDatum ?? ''),
            new Date(currentKodbeh?.giltigTomDatum ?? ''),
            bokforderDate
          );

          const hasBokforderKodbeh =
            currentUser.bokforderkodbehorigheter?.filter(
              kodbeh => kodbeh?.FOR_BOKFORDER
            ).length != 0;
          if (isValidByBokforderDate && currentKodbeh?.[kodbehType]) {
            return [...kodbehArray, currentKodbeh];
          } else if (
            kodbehType === 'FOR_BOKFORDER' &&
            isEconomyPersonnel &&
            currentUser.userID === userID &&
            !hasBokforderKodbeh
          ) {
            return [...kodbehArray, { ...currentKodbeh, FOR_BOKFORDER: true }];
          } else {
            return kodbehArray;
          }
        },
        [] as UserBokforderKodbehorigheterQuery_userBokforderKodbehorigheter_bokforderkodbehorigheter[]
      );

      if (newKodbehorigheter && newKodbehorigheter.length > 0) {
        const updatedCurrentUser = {
          ...currentUser,
          bokforderkodbehorigheter: newKodbehorigheter,
        };
        return [...validUsers, updatedCurrentUser];
      } else {
        return validUsers;
      }
    } else {
      return validUsers;
    }
  }, [] as UserBokforderKodbehorigheterQuery_userBokforderKodbehorigheter[]);

  return createUsersWithKodbehorigheter(
    allUsersBasedOnType,
    avenyCollectionMap
  );
};

export const isCellDisabledBfo = (
  params: GridCellParams<any, any, any>,
  status: TEDEKBokforderSTATUSEnum,
  showAttestantKonteraSwitch: boolean,
  editKontering: boolean,
  bokforderVariant: TEDEKBokforderVariantEnum | DefaultBfoVariantEnum | null,
  templateRows: ITemplateRow[]
) => {
  //Ska endast gå att ändra attestant och radtext när man arbetar med en utanordning tillgodohavande
  if (
    bokforderVariant === TEDEKBokforderVariantEnum.UTANORDNINGTILLGODO &&
    params.row?.id !== SUMROWID &&
    params.field !== 'Attestant.Name' &&
    params.field !== 'TEXT'
  ) {
    return true;
  }
  if (params.field == 'MenuColumn') {
    return false;
  }
  //Om raden redan är attesterad
  if (params.row?.collectionData?.ATTESTERAD_DATUM != null) {
    return true;
  }

  //Om sysoptionen för att attstant ska kunna redigera så behöver man gå in redigeringsläge för ändra något i griden
  if (
    status === TEDEKBokforderSTATUSEnum.VANTAR_PA_ATTEST &&
    showAttestantKonteraSwitch &&
    !editKontering
  ) {
    return true;
  }
  if (
    bokforderVariant === TEDEKBokforderVariantEnum.PERIODISERA &&
    params.field !== 'Attestant.Name' &&
    params.row?.id !== SUMROWID &&
    params.field !== 'MenuColumn' &&
    params.field !== 'TEXT'
  ) {
    return true;
  }

  if (params.row?.collectionData?.REF_LOPNR != null) {
    if (
      (bokforderVariant === TEDEKBokforderVariantEnum.OMBOKFOR ||
        bokforderVariant === TEDEKBokforderVariantEnum.VAND) &&
      params.field !== 'Attestant.Name'
    ) {
      return true;
    } else {
      return false;
    }
  }

  if (
    bokforderVariant === TEDEKBokforderVariantEnum.MALL &&
    params.row?.collectionData?.MALLRAD_LOPNR != null
  ) {
    const currentTemplateRow = templateRows.find(
      templateRow => templateRow.id === params.row?.collectionData.id
    );
    if (currentTemplateRow != null) {
      //Disable:a DEBET om mallraden ska användas för KREDIT
      if (
        params.field === 'DEBET' &&
        currentTemplateRow.debetOrKredit ===
          TEDEKBokforingsmallRadDEB_KREDEnum.KREDIT
      ) {
        return true;
      }
      //Disable:a KREDIT om mallraden ska användas för DEBET
      if (
        params.field === 'KREDIT' &&
        currentTemplateRow.debetOrKredit ===
          TEDEKBokforingsmallRadDEB_KREDEnum.DEBET
      ) {
        return true;
      }
    }

    return false;
  }

  return false;
};
